module.exports = __webpack_public_path__ + "img/META.e4dff1a3.png";